// import './ShippingLabelsSection.scss';

import { useMemo } from 'react';
import { Outlet } from 'react-router';

import SpinLoading from '@/components/general/SpinLoading';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useInitialLoading } from '@/hooks/useInitialLoading';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';

const ShippingLabelsSection = () => {
  useDocumentTitle({
    resourceTitle: 'Direcciones',
    showTitle: 'Ver dirección {id}',
    editTitle: 'Editar dirección {id}',
    createTitle: 'Nueva dirección',
  });

  const { selectProps: companySelectProps } = useSelectScrollSearch(
    {
      resource: 'empresas',
      optionLabel: (item: any) => item.full_name,
    },
    { saveItem: true },
  );
  const { selectProps: paisesSelectProps } = useSelectScrollSearch(
    {
      resource: 'paises',
      optionLabel: (item: any) => `${item.nombre}`,
    },
    { searchField: 'nombre' },
  );
  const isLoading = useMemo(() => {
    return paisesSelectProps.loading || companySelectProps.loading;
  }, [paisesSelectProps.loading, companySelectProps.loading]);
  const { initialLoading } = useInitialLoading(isLoading);

  return (
    <div className="ShippingLabelsSection MainSection">
      {initialLoading ? (
        <SpinLoading />
      ) : (
        <Outlet context={{ paisesSelectProps, companySelectProps }} />
      )}
    </div>
  );
};

export default ShippingLabelsSection;
